import { Pipe, PipeTransform } from '@angular/core';
import { Address } from '../../models/altinn-application/address';

@Pipe({
  name: 'formatAddress'
})
export class FormatAddressPipe implements PipeTransform {

  transform(value: Address | null | undefined): string {
    // The model marks address as required, so an absent one means the backend broke its own
    // contract. Blank out this one line rather than taking down the whole status page.
    if (!value) {
      return '';
    }

    // Joined rather than concatenated because streetName is optional: on its own it would render
    // the literal "undefined", and a bare street number would carry a leading space.
    const street = [value.streetName, value.streetNumber].filter(Boolean).join(' ');
    const addresLine2 = value.addresLine2 ? `, ${value.addresLine2}` : ''
    const city = value.city
      ? value.zipCode ? `, ${value.zipCode} ${value.city}` : `, ${value.city}`
      : '';
    return `${street}${addresLine2}${city}`;
  }

}
